import React from 'react';
import { Formik } from 'formik';
import classNames from 'classnames';
import { useUpdateProjectTagMutation } from '../../store';
import { Modal } from '../../components';
import { QuickAlert } from '../../components';

export const EditTagModal = (props) => {
    const { show, onClose, projectId, tag } = props;
    const [updateProjectTag] = useUpdateProjectTagMutation();

    const handleSubmit = async (values, formikHelpers) => {
        const tagObject = { ...values, index: tag.index };
        updateProjectTag({ id: projectId, tag: tagObject });
        formikHelpers.setSubmitting(false);
        onClose();
    };

    const handleValidate = (values) => {
        let errors = {};
        return errors;
    };

    return (
        <Modal
            fitContent
            show={show}
        >
            <div className="sm:container p-4">
                <h1>Tag</h1>
                <div>
                    <Formik
                        initialValues={tag}
                        validate={handleValidate}
                        onSubmit={handleSubmit}
                    >
                        {(formik) => (
                            <form onSubmit={formik.handleSubmit}>
                                {Object.keys(formik.errors ?? {}).map(
                                    (k) =>
                                        formik.touched?.[k] && (
                                            <QuickAlert
                                                key={k}
                                                kind="error"
                                                msg={formik.errors?.[k]}
                                            />
                                        ),
                                )}
                                <div className="mb-4">
                                    <div className="flex justify-between gap-4 mb-2">
                                        <div>
                                            <label
                                                className={classNames(
                                                    'block mb-2 text-sm font-medium',
                                                )}
                                                htmlFor={'value'}
                                            >
                                                Tag
                                            </label>
                                            <div className="swegon-ui-text-input-wrapper">
                                                <input
                                                    type="text"
                                                    name={'value'}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    value={formik.values.value}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <label
                                                className={classNames(
                                                    'block mb-2 text-sm font-medium',
                                                )}
                                                htmlFor={'equipmentType'}
                                            >
                                                Equipment Type
                                            </label>
                                            <div className="swegon-ui-text-input-wrapper">
                                                <input
                                                    type="text"
                                                    name={'equipmentType'}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    value={
                                                        formik.values
                                                            .equipmentType
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <label
                                                className={classNames(
                                                    'block mb-2 text-sm font-medium',
                                                )}
                                                htmlFor={'room'}
                                            >
                                                Room
                                            </label>
                                            <div className="swegon-ui-text-input-wrapper">
                                                <input
                                                    type="text"
                                                    name={'room'}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    value={formik.values.room}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <label
                                                className={classNames(
                                                    'block mb-2 text-sm font-medium',
                                                )}
                                                htmlFor={'trade'}
                                            >
                                                Trade
                                            </label>
                                            <div className="swegon-ui-text-input-wrapper">
                                                <input
                                                    type="text"
                                                    name={'trade'}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    value={formik.values.trade}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex justify-end">
                                    <button
                                        onClick={onClose}
                                        type="button"
                                        className="swegon-like-button outlined mr-4 !px-4 amber"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="swegon-like-button contained"
                                        type="submit"
                                        disabled={formik.isSubmitting}
                                    >
                                        Update
                                    </button>
                                </div>
                            </form>
                        )}
                    </Formik>
                </div>
            </div>
        </Modal>
    );
};
